import React, { ChangeEvent, useCallback } from 'react';
import SearchIcon from '../../../../ui/svg/common/search';
import { useAppSelector } from '../data/store';
import { rootActions } from '../data/store';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import { getSearchData } from '../data/data-service';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const SearchTextBox = () => {

    const dispatch = useDispatch();

    const query = useAppSelector(store => store.root.query);

    const updateUrl = (inputText: string) => {
        const url = new URL(window.location.href.toLowerCase());
        url.searchParams.set('q', encodeURIComponent(inputText));
        window.history.replaceState({}, '', url.toString());
    };

    const search = async (inputText: string) => {
        updateUrl(inputText.toLowerCase().trim());

        if(inputText.trim() === ''){
            dispatch(
                rootActions.main({
                    filtered: [],
                })
            );

            dispatch(
                rootActions.setQuery({
                    query: '',
                })
            );
            return;
        }

        dispatch(
            rootActions.main({
                isLoading: true,
            })
        );

        const response = await getSearchData(inputText);

        dispatch(
            rootActions.main({
                isLoading: false,
            })
        );

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData){
            return;
        }

        const responseResults = response.data.relatedData || [];

        if(inputText.length > 1) {
            // q: {query} | rc: {number of results}
            // q: api | rc: 4
            sendGAEvent('SQLSearchQuery', `q: ${ inputText.toLowerCase() } | rc: ${ responseResults.length }`);
        }

        dispatch(
            rootActions.main({
                filtered: responseResults,
            })
        );
    };

    // debounce is an external dependency, and it can't be replaced with inline function
    // eslint-disable-next-line
    const debounced = useCallback(
        debounce(
            (inputText) => search(inputText),450
        ),
        []
    );

    const changeHandler = (evt: ChangeEvent<HTMLInputElement>) => {

        dispatch(
            rootActions.setQuery({
                query: evt.target.value,
            })
        );

        debounced(evt.target.value);
    };

    return (
        <div className="waves-box-sm border box-border border-gray-200-ho bg-gray-100 outline-none rounded-full flex items-center justify-center">
            <input
                type="text"
                className="bg-gray-100 rounded-full flex-1 p-3 md:p-5 outline-none pl-6 xl:pl-8"
                placeholder="Search"
                aria-label="Search"
                value={ query }
                onChange={ changeHandler }
            />

            <button
                type="button"
                className="p-3 md:p-5 pr-4 xl:pr-8 cursor-pointer">
                <SearchIcon width="15px" color="#252525" title="Filter" />
            </button>
        </div>
    )
};

export default  SearchTextBox;